import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { Card, CardTitle } from './cardStyles'
import { getDocName } from 'hooks/useDocListData'
import DocumentUpload from 'images/documentUpload'
import { MESSAGES } from '../../messages/messages'

const PendingCard = ({ id, selectFile = () => {}, onKeyDownHandler = () => {}, ...props }) => {
    const documentName = getDocName(props)

    return (
        <Card
            tabIndex={0}
            data-testid={id}
            sx={{
                border: '1px solid rgb(5, 98, 210)',
                justifyContent: 'center',
                borderRadius: 4,
                padding: 4,
                boxShadow: '0'
            }}
            onClick={selectFile}
            onKeyDown={onKeyDownHandler}
        >
            <Box>
                <Box
                    sx={{
                        display: 'grid',
                        justifyItems: 'start'
                    }}
                >
                    <Box
                        sx={{
                            display: 'grid',
                            width: '100%',
                            gridAutoFlow: 'column',
                            gap: '0',
                            lineHeight: '0'
                        }}
                    >
                        <CardTitle
                            sx={{
                                typography: 'boldBody2',
                                letterSpacing: '0'
                            }}
                            data-testid="document-name"
                        >
                            {documentName}
                        </CardTitle>
                        <Box
                            aria-hidden="true"
                            role="img"
                            aria-label="add icon"
                            data-testid="action-add"
                            sx={{
                                color: 'primary.main',
                                p: 0,
                                textAlign: 'right',
                                paddingLeft: 1
                            }}
                        >
                            <DocumentUpload />
                        </Box>
                    </Box>

                    <Box>
                        <Typography
                            color="common.charcoal.main"
                            component="span"
                            data-testid="document-status"
                            sx={{
                                typography: 'regularBody3',
                                letterSpacing: 0,
                                backgroundColor: 'common.gray.11',
                                padding: 1,
                                borderRadius: 1
                            }}
                        >
                            {MESSAGES.requested}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Card>
    )
}

PendingCard.propTypes = {
    id: PropTypes.number,
    selectFile: PropTypes.func,
    onKeyDownHandler: PropTypes.func
}

export default PendingCard
